/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
import Cons from 'Constant';
export default {
  props: {
    text: {
      type: String,
      "default": '我是底线～'
    }
  },
  data: function data() {
    return {};
  }
};